import React from "react";
import { History, Paperclip } from "lucide-react";
import { useApp, formatBRL, formatDate } from "../context/AppContext";

const ACOES = {
  emitido: { label: "Boleto emitido", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  reemitido: { label: "Boleto reemitido", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  cancelado: { label: "Boleto cancelado", cls: "bg-red-50 text-red-700 border-red-200" },
  cancelado_reemissao: { label: "Cancelado p/ reemissão", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  pago_pix: { label: "Pago via Pix", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

const quando = (iso) => {
  if (!iso) return "";
  const [d, t] = String(iso).split("T");
  return `${formatDate(d)}${t ? ` ${t.slice(0, 5)}` : ""}`;
};

export const HistoricoBoletos = ({ eventos, faturaKey, residenteId }) => {
  const { getDocumentoBlob } = useApp();
  const abrirComprovante = async (docId) => {
    try {
      const blob = await getDocumentoBlob(residenteId, docId);
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch { /* sem acesso */ }
  };
  if (!eventos || eventos.length === 0) return null;
  return (
    <div className="rounded-lg border border-slate-200 bg-white px-3 py-2.5" data-testid={`historico-boletos-${faturaKey}`}>
      <p className="text-xs font-semibold text-slate-500 uppercase mb-2 flex items-center gap-1.5"><History className="w-3.5 h-3.5" /> Histórico de cobrança</p>
      <ul className="space-y-1.5">
        {[...eventos].reverse().map((e) => {
          const a = ACOES[e.acao] || { label: e.acao, cls: "bg-slate-50 text-slate-700 border-slate-200" };
          return (
            <li key={e.id} className="text-xs text-slate-600 flex flex-wrap items-center gap-x-2 gap-y-0.5" data-testid={`historico-boleto-item-${e.id}`}>
              <span className={`inline-flex px-1.5 py-0.5 rounded border font-semibold ${a.cls}`}>{a.label}</span>
              <span className="font-semibold text-slate-800">{formatBRL(e.valor)}</span>
              {e.vencimento && <span>{e.acao === "pago_pix" ? "pago em" : "venc."} {formatDate(e.vencimento)}</span>}
              <span className="text-slate-400">· {quando(e.em)}</span>
              <span className="text-slate-500">· por <b className="text-slate-700">{e.por || "—"}</b></span>
              {e.asaasPaymentId && <span className="text-slate-400 font-mono">· {e.asaasPaymentId}</span>}
              {e.documentoId && <button type="button" className="inline-flex items-center gap-1 text-emerald-700 hover:underline" onClick={() => abrirComprovante(e.documentoId)} data-testid={`historico-comprovante-${e.id}`}><Paperclip className="w-3 h-3" /> Ver comprovante</button>}
              {e.detalhe && <span className="text-slate-400 italic w-full">{e.detalhe}</span>}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
